import type { FaireProductEntity } from "../../entity_types/product";

export const p_q5gsng2er3: FaireProductEntity = {
  token: "p_q5gsng2er3",
  type: "product",
  name: "Vintage Gold Hoops - Variety",
  brandToken: "b_2yc6uznjzg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/acaac1c767e29d393ced83394a9b23caf98236441dbc1474cea4533228ed29c5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b4e912037e90ddaa5d8ea760227022a14fdd109ca6a6a3d29eb70317fd6a1dfc.jpeg",
    "https://cdn.faire.com/fastly/e924cf40a16384a6e8dfe22db5f0d60513e24ca043d76d168a9989130b417b5f.jpeg",
    "https://cdn.faire.com/fastly/88e874cfd4a52c6717264fe842cfe9bcc7dbf076706a4310b8293ef437ca8bd7.jpeg",
    "https://cdn.faire.com/fastly/64123524e4d541561fa6a66274c85d2a81d9a218f6ecee72c5cd44e3f46b99de.jpeg",
    "https://cdn.faire.com/fastly/989fd3226f3070c25399c2dc57f24d3012e42fee6aea570c53afb6836b85dd6a.jpeg",
    "https://cdn.faire.com/fastly/1c17f7d3fc4addcb0a905134f2435d104cd814b32633933e85a4bdf19eebc8cc.jpeg",
    "https://cdn.faire.com/fastly/ba80b73eb4a9e937df4b975126a58d3f703fa0c92603cf13173b76451344fd6f.jpeg",
  ],
  priceDollars: 13.86,
  description:
    "Deadstock vintage gold-plated hoop earrings in various styles, shapes, and sizes. These photos are a representation of what you will receive - there are many more styles not pictured, but we will make sure you get a good variety. Minimum of 10 hoops.\n\nThey will come carded on mini playing cards with our branding, unless you request otherwise before shipping. Playing cards vary. \n\nEach individual hoop sells for $9 wholesale, $18 MSRP. ",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:17.952Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
